import { useEffect, useState } from "react";

// PRD #3 "DOTORE Grand Promotion Banner": a thin bar above the hero. Each message
// "falls" in from the top, then the bar rotates through the configured messages.
// Clicking a message goes to its configured course page.
// CMS-driven via props.messages = [{ text, link }]. Empty -> the ticker is hidden
// (configure messages in Umbraco; links may be left empty for non-clickable messages).

export default function PromoTicker({ props }) {
  const messages = (Array.isArray(props?.messages) ? props.messages : []).filter(
    (m) => m && m.text
  );
  const interval = Number(props?.interval) > 0 ? Number(props.interval) : 3500;
  const badge = props?.badge || "EVENT";

  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (messages.length <= 1) return;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % messages.length), interval);
    return () => clearInterval(t);
  }, [messages.length, interval]);

  if (messages.length === 0) return null;

  const cur = messages[idx % messages.length];

  const onClick = (e) => {
    if (!cur?.link) {
      e.preventDefault();
      return;
    }
  };

  return (
    <div className="promo-ticker" role="region" aria-label="Promotions">
      <div className="promo-ticker__inner">
        <span className="promo-ticker__badge">{badge}</span>
        {/* key={idx} remounts the message so the fall animation replays each rotation */}
        <a
          key={idx}
          className="promo-ticker__msg"
          href={cur?.link || undefined}
          onClick={onClick}
        >
          {cur?.text}
        </a>
      </div>
    </div>
  );
}
